<template>
    <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
                <div class="row align-items-center">
                    <div class="col-8">
                        <h3 class="mb-0">Benutzer editieren</h3>
                    </div>
                </div>
            </div>
            <template>
                <tabs>
                    <tab-pane title="Allgemein">
                        <form @submit.prevent="editUser($route.params.id)">
                            <base-alert v-if="status.type !== ''" :type="status.type">{{ status.msg }}</base-alert>
                            <h6 class="heading-small text-muted mb-4">Angaben zum Benutzer</h6>
                            <userform ref="UForm" :loading-prop="isLoading"/>
                            <!-- Address -->
                            <button class="btn btn-icon my-4 btn-primary" :key="tick" :disabled="isLoading">
                                <span class="btn-inner--icon"><i v-if="isLoading" class="fas fa-circle-notch fa-spin"></i><i v-else class="ni ni-fat-add"></i></span>
                                <span class="btn-inner--text">Benutzerdaten ändern</span></button>
                        </form>
                    </tab-pane>
                    <tab-pane title="Erweiterte Rechte">
                        <h6 class="heading-small text-muted mb-4">Erweiterte Benutzerrechte</h6>
                        <ul class="text-muted mb-4">
                            <li>Über "Zugriff auf folgende Organisationen" können sie einem Benutzer mit der Rolle "Betreiber" Zugriff auf weitere Organisationen erteilen.</li>
                            <li>Über "Zugriff auf folgende Standorte" können Sie einem Benutzer mit der Rolle "Service" Zugriff auf weitere Standorte erteilen. Dies ermöglicht dein Einsatz von "Springern".</li>
                        </ul>
                        <p class="text-muted mb-4">Bitte beachten Sie, dass Benutzer mit der Rolle "Betreiber" auf alle Standorte innerhalb dieser Organisation zugreifen können.
                        </p>
                        <div class="row" :v-if="!isLoading && mountd">
                            <div class="col">
                                <UserLocations :uid="$route.params.id" :customer="customer" ref="userloc"></UserLocations>
                            </div>
                            <div class="col">
                                <UserCustomers :uid="$route.params.id" :customer="customer" ref="usercus"></UserCustomers>
                            </div>
                        </div>
                    </tab-pane>
                </tabs>
            </template>
        </card>
</template>

<script>

    import Userform from "@/views/Users/Userform";
    import UserLocations from "@/views/Users/UserLocations";
    import UserCustomers from "@/views/Users/UserCustomers";


    export default {
        name: "edit",
        components: {UserCustomers, UserLocations, Userform},
        data() {
            return {
                isLoading: true,
                status: {
                    type: '',
                    msg: ''
                },
                mountd: false,
                customer: '',
                tick: 12
            }
        },
        created() {
            this.showUser(this.$route.params.id)
        },
        mounted() {
            this.mountd = true;
        },
        methods: {
            userdata () {
                return this.$refs.UForm;
            },
            showUser(id) {
                return new Promise(() => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    const requestOptions = {
                        method: 'GET',
                        headers: header,
                    };
                    this.isLoading = true;
                    fetch(process.env.VUE_APP_API_SERVER + `/api/users/`+id, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                                this.isLoading = false;
                                this.$refs.UForm.user = response;
                                if (typeof response.location !== 'undefined') this.$refs.UForm.user.location = response.location['@id'];
                                if (typeof response.customer !== 'undefined') {
                                    this.$refs.UForm.user.customer = response.customer['@id'];
                                    this.customer = this.$refs.UForm.user.customer;

                                }
                                this.tick++;
                            },
                            error => {
                                this.isLoading = false;
                                this.tick++;
                                this.status =  {type: 'danger', msg: error};
                            });
                });
            },
            editUser(id) {
                return new Promise(() => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/merge-patch+json';
                    let senddata = this.$refs.UForm.user;
                    const requestOptions = {
                        method: 'PATCH',
                        headers: header,
                        body: JSON.stringify(senddata)
                    };
                    this.isLoading = true;
                    fetch(process.env.VUE_APP_API_SERVER + `/api/users/`+id, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                                this.isLoading = false;
                                this.status =  {type: 'success', msg: 'Benutzer '+response.firstname+' '+response.lastname+' (ID: '+response.id+') wurde editiert.'};
                                this.$refs.userloc.init();
                                this.$refs.usercus.init();
                                this.tick++;
                            },
                            error => {
                                this.isLoading = false;
                                this.status =  {type: 'danger', msg: error};
                                this.tick++;
                            });
                });
            },
            isAdmin() {
                return this.$store.getters['authentication/isAdmin'];
            }
        }
    }
</script>

<style scoped>

</style>